export default <any>{
  ckb: {
    ja: () => import('./ckb.ja'),
    ko: () => import('./ckb.ko')
  },
  policy: {
    ja: () => import('./policy.ja'),
    ko: () => import('./policy.ko')
  }
}
